var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-application" },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": _vm.dialogMaxWidth,
            persistent: _vm.persistent,
            transition: _vm.modal.center ? null : "dialog-right-transition",
            "content-class": _vm.dialogContentClass
          },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c(
            "v-card",
            { class: _vm.cardClass, style: _vm.cardStyle },
            [
              _vm.closable
                ? _c(
                    "v-btn",
                    {
                      class: _vm.closeButtonClass,
                      style: _vm.closeButtonStyle,
                      attrs: { icon: "", small: _vm.v2 },
                      on: {
                        click: function($event) {
                          _vm.show = !_vm.show
                        }
                      }
                    },
                    [
                      _vm.v2
                        ? _c("icon-svg", {
                            attrs: {
                              name: "close",
                              size: "15",
                              color: "#8e8e8e"
                            }
                          })
                        : _c("icon-svg", {
                            staticClass: "modal-close-button",
                            attrs: { name: "close" }
                          })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-card-title",
                { class: _vm.cardTitleClass },
                [
                  _vm.v2
                    ? _c("span", { class: _vm.$style.modal_title }, [
                        _vm._v(_vm._s(_vm.modal.title))
                      ])
                    : _c("Title", {
                        attrs: {
                          title: _vm.modal.title,
                          subtitle: _vm.modal.subtitle
                        }
                      })
                ],
                1
              ),
              _c("v-card-text", { class: _vm.cardTextClass }, [
                _vm.showIcon
                  ? _c(
                      "div",
                      { staticClass: "mb-4" },
                      [
                        _c("icon-svg", {
                          attrs: {
                            size: "40",
                            name: _vm.modalIconName,
                            color: _vm.modalIconColor
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.modal.text
                  ? _c(
                      "span",
                      {
                        class: _vm.v2 ? _vm.$style.modal_text : "",
                        style: _vm.textStyle
                      },
                      [_vm._v(" " + _vm._s(_vm.modal.text) + " ")]
                    )
                  : _vm._e(),
                _vm.modal.html
                  ? _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.modal.html) }
                    })
                  : _vm._e()
              ]),
              _c(
                "v-card-actions",
                { class: _vm.cardActionsClass },
                [
                  !_vm.v2 ? _c("v-spacer") : _vm._e(),
                  _vm._l(_vm.modal.buttons, function(b, i) {
                    return [
                      _c(
                        "BaseButton",
                        _vm._b(
                          {
                            key: i,
                            class: _vm.v2 ? "mx-2" : "",
                            attrs: {
                              loading: _vm.loadings[b.text],
                              "min-width": _vm.v2 ? _vm.buttonsWidth : undefined
                            },
                            on: {
                              click: function($event) {
                                return _vm.close(b)
                              }
                            }
                          },
                          "BaseButton",
                          _vm.getButtonBind(b, i),
                          false
                        ),
                        [_vm._v(" " + _vm._s(b.text) + " ")]
                      )
                    ]
                  }),
                  !_vm.v2 ? _c("v-spacer") : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }